const InsuranceChallenge2HintsText =
    ["It is essential that you understand what your policy does ... AND.... does not " +
         "cover",
     "Your renter's (apartment) insurance does not cover damage done to the building",
     "Skipping health insurance is never a good plan, life is unpredictable!",
     "Insurance is a good thing, but it doesn't cover everything, so you need to " +
         "have another way to pay for unexpected items that aren't covered by insurance."
    ]

export default InsuranceChallenge2HintsText;